import React, { useContext } from "react";

import { getFilteredTermAggregationBuckets } from "@examspark/common";
import { languageMeta } from "@examspark/common/dist/meta/assets";
import { gradeLevelList, gradeLevelMeta } from "@examspark/common-meta";
import { VSpace } from "@examspark/common-ui";

import SearchContext from "../../../../providers/SearchContext";
import FacetCheckboxFilter from "../../../filters/FacetCheckboxFilter";

const PassagePickerFilters = () => {
  const search = useContext(SearchContext);

  return (
    <VSpace size="2rem">
      {/* <FacetCheckboxFilter
        propertyName="Passage Genre"
        isLoading={search?.facets.isLoading}
        options={[]}
        selected={search?.state.filter.language ?? []}
        onFilterChange={(values) => {
          search?.dispatch({
            type: "UPDATE",
            data: {
              language: values,
            },
          });
        }}
      /> */}
      <FacetCheckboxFilter
        propertyName="Language"
        isLoading={search?.facets.isLoading}
        labelOverrides={{
          EN: languageMeta["EN"].label,
          ES: languageMeta["ES"].label,
        }}
        options={
          getFilteredTermAggregationBuckets(
            search?.facets.data?.aggregations as any,
            "language",
          ).map((agg) => {
            return {
              label: agg.key,
              value: agg.key,
              count: String(agg.doc_count),
            };
          }) ?? []
        }
        selected={search?.state.filter.language ?? []}
        onFilterChange={(values) => {
          search?.dispatch({
            type: "UPDATE",
            data: {
              language: values,
            },
          });
        }}
      />
      <FacetCheckboxFilter
        propertyName="Subject"
        isLoading={search?.facets.isLoading}
        options={
          getFilteredTermAggregationBuckets(
            search?.facets.data?.aggregations as any,
            "subject",
          ).map((agg) => {
            return {
              label: agg.key,
              value: agg.key,
              count: String(agg.doc_count),
            };
          }) ?? []
        }
        labelOverrides={{
          ELA: "English Language Arts",
          SLA: "Spanish Language Arts",
          MATH: "Mathematics",
          SCI: "Science",
          SS: "Social Studies",
        }}
        selected={search?.state.filter.subject ?? []}
        onFilterChange={(values) => {
          search?.dispatch({
            type: "UPDATE",
            data: {
              subject: values,
            },
          });
        }}
      />
      <FacetCheckboxFilter
        propertyName="Grade"
        isLoading={search?.facets.isLoading}
        options={
          getFilteredTermAggregationBuckets(
            search?.facets.data?.aggregations as any,
            "grade",
          ).map((agg) => {
            return {
              label: agg.key,
              value: agg.key,
              count: String(agg.doc_count),
            };
          }) ?? []
        }
        labelOverrides={gradeLevelList.reduce(
          (acc, grade) => {
            acc[grade] = gradeLevelMeta[grade].label;
            return acc;
          },
          {} as Record<string, string>,
        )}
        selected={search?.state.filter.grade ?? []}
        onFilterChange={(values) => {
          search?.dispatch({
            type: "UPDATE",
            data: {
              grade: values,
            },
          });
        }}
      />
    </VSpace>
  );
};

export default PassagePickerFilters;
